export const TaskManagementTypesEnum = {
  FORM: {
    key: 903,
  },
  OFFER: {
    key: 902,
  },
  SCORECARD: {
    key: 919,
  },
};
